<template>
    <div class="substitution">
        <img
            src="@/assets/img/reaktionen/elektrophile-substitution/elektrophile-substitution.jpg"
            alt="Elektrophile Substitution"
            title="Elektrophile Substitution"
            width="100%"
        />
        <small
            ><a
                href="http://jagemann-net.de/chemie/reaktionen/SE/SEerst/SEerst.php"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'elektrophile-substitution-mechanismus',
};
</script>
